import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Modal, IconArrowHead } from '..';
import InfoForm from './InfoForm/InfoForm';
import MonthlyHoursForm from './MonthlyHoursForm/MonthlyHoursForm';
import TutorTypeForm from './TutorTypeForm/TutorTypeForm';
import PackagesForm from './PackagesForm/PackagesForm';
import PurchaseForm from './PurchaseForm/PurchaseForm';
import css from './PackagesModal.module.css';

const PackagesModal = props => {
  const {
    intl,
    isOpen,
    onClose,
    onManageDisableScrolling,
    onSubmit,
    initialData = {},
    orders,
  } = props;

  const [current, setCurrent] = useState(0);
  const [visited, setVisited] = useState(new Set([0]));
  const [data, setData] = useState(initialData);

  const steps = [
    { id: 'info', component: InfoForm },
    { id: 'monthlyHours', component: MonthlyHoursForm },
    // { id: "tutorType", component: TutorTypeForm },
    { id: 'packages', component: PackagesForm },
    { id: 'purchase', component: PurchaseForm },
  ];

  const Current = steps[current].component;

  /** Merge new values for the active step into the global form object */
  const updateStepData = (stepId, values) => setData(prev => ({ ...prev, [stepId]: values }));
  /** Advance to next step */
  const next = vals => {
    const stepId = steps[current].id;
    updateStepData(stepId, vals);
    setCurrent(i => {
      const nxt = Math.min(i + 1, steps.length - 1);
      setVisited(v => new Set(v).add(nxt));
      return nxt;
    });
  };

  const handleSubmit = vals => {
    const stepId = steps[current].id;
    onSubmit({ ...data, [stepId]: vals });
  };

  /** Go back one step */
  const back = () => setCurrent(i => Math.max(i - 1, 0));

  /** Jump to any previously visited step */
  const goto = idx => visited.has(idx) && setCurrent(idx);

  return (
    <Modal
      id="packages-modal"
      contentClassName={css.modalContent}
      isOpen={isOpen}
      onClose={onClose}
      onManageDisableScrolling={onManageDisableScrolling}
      usePortal
    >
      <div className={css.contentWrap}>
        <section>
          {current >= 2 && current < steps.length ? (
            <div className={css.backLink} onClick={back}>
              <IconArrowHead direction="left" size="big" />
              {intl.formatMessage({ id: 'PackagesModal.backLink' })}
            </div>
          ) : null}
          <Current
            data={data || {}}
            onSubmit={current < steps.length - 1 ? next : handleSubmit}
            intl={intl}
            orders={orders}
            initialValues={{ monthlyTutoringHours: '8' }}
          />
        </section>
      </div>
    </Modal>
  );
};

PackagesModal.propTypes = {
  id: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onManageDisableScrolling: PropTypes.func.isRequired,
};

export default PackagesModal;
